import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faHourglassHalf } from "@fortawesome/pro-regular-svg-icons";

export default function Footer() {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<Layout.Footer className="navigation">
			<Button
				className={`icon home ${
					location.pathname === "/dashboard" ? "active" : ""
				}`}
				onClick={() => navigate("/")}
				type="link"
			>
				<div className="item">
					<FontAwesomeIcon icon={faHome} />
					<div className="label">Home</div>
				</div>
			</Button>
			<Button
				className={`icon news ${
					location.pathname === "/survey/pending" ? "active" : ""
				}`}
				onClick={() => navigate("/survey/pending")}
				type="link"
			>
				<div className="item">
					<FontAwesomeIcon icon={faHourglassHalf} />
					<div className="label">Pending</div>
				</div>
			</Button>
		</Layout.Footer>
	);
}
